import { render, staticRenderFns } from "./ItemBemPermanenteList.vue?vue&type=template&id=68001110&scoped=true"
import script from "./ItemBemPermanenteList.vue?vue&type=script&lang=js"
export * from "./ItemBemPermanenteList.vue?vue&type=script&lang=js"
import style0 from "./ItemBemPermanenteList.vue?vue&type=style&index=0&id=68001110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68001110",
  null
  
)

export default component.exports